import './BetbookScoreboard.less';

import React from 'react';
import clsx from 'clsx';
import moment from 'moment/moment';
import { formatDate } from '../../common/util';
import i18n from '../../common/i18n';
import { SportIconNui } from '../../icons/SportIconNui';

export interface BetbookScoreboardProps {
    className?: string;
    iconSize?: string;
    matchStartDate: string;
    participants: string[];
    tournamentName?: string;
    sportId: string | number;
}

export default function BetbookScoreboard({
    className = '',
    iconSize = '22',
    matchStartDate,
    participants,
    tournamentName,
    sportId
}: BetbookScoreboardProps) {
    const home = typeof participants === 'object' ? participants[0] : participants;
    const away = typeof participants === 'object' && participants[1];

    //variables for start date element
    const startOfToday = moment().startOf('day');
    const endOfToday = moment().endOf('day');
    const endOfTomorrow = moment()
        .add(1, 'days')
        .endOf('day');
    const matchStart = moment(matchStartDate);
    const expirationTime = formatDate(matchStart, 'HH:mm');
    const expirationDate = formatDate(matchStart, 'DD.MM.YYYY - HH:mm');
    const dateText = matchStart.isBetween(startOfToday, endOfToday)
        ? i18n('betbook.analysis.expiration.today') + ' ' + expirationTime
        : matchStart.isBetween(endOfToday, endOfTomorrow)
        ? i18n('betbook.analysis.expiration.tomorrow') + ' ' + expirationTime
        : expirationDate;

    return (
        <div className={clsx('betbook-scoreboard', `bg-${sportId}`, className)}>
            <div className="scoreboard-inner-element">
                {sportId ? (
                    <SportIconNui
                        sportId={sportId}
                        sizeX={iconSize}
                        sizeY={iconSize}
                        className="scoreboard-sport-icon"
                    />
                ) : null}
                <div className="scoreboard-tournament-wrapper">
                    <div className="scoreboard-rectangle scoreboard-rect-left" />
                    <div className="scoreboard-tournament">{tournamentName}</div>
                    <div className="scoreboard-rectangle" />
                </div>
                <div
                    className={clsx('scoreboard-opponent-wrapper full-width c-white f-condensed text-extra-bold', {
                        'justify-center': !away
                    })}
                >
                    <div className={clsx('scoreboard-opponent', { 'scoreboard-opponent-left': away })}>{home}</div>
                    {away && (
                        <>
                            <div className="scoreboard-vs fs-18">VS</div>
                            <div className="scoreboard-opponent-right">{away}</div>
                        </>
                    )}
                </div>
                <div className=" betbook-scoreboard-date p-rel br-radius-2">{dateText}</div>
            </div>
        </div>
    );
}
